import styled from 'styled-components';
import { BdsIllustration } from 'blip-ds/dist/blip-ds-react';
import colors from '_colors.module.scss';

export const Illustration = styled(BdsIllustration)`
  mix-blend-mode: luminosity;
  opacity: 50%;
  width: 120px;
`;

export const Subtitle = styled.div`
  bds-typo {
    color: ${colors.ContentDisable};
  }
`;
